<script lang="ts" setup>
import { onBeforeUnmount, onMounted } from 'vue';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import type { ImUserVO } from '~/types/im';
import { ContextService } from './Context.service';
import ImChatBox from './components/ImChatBox.vue';
import ImChatEntry from './components/ImChatEntry.vue';
import { AudioActionService } from './components/action/AudioAction.service';
import { CodeActionService } from './components/action/CodeAction.service';
import { EmojiActionService } from './components/action/EmojiAction.service';
import { ImageActionService } from './components/action/ImageAction.service';
import { ScreenshotActionService } from './components/action/ScreenshotAction.service';
import { EventService } from './event.service';
import { ImService } from './im.service';
import { MessageService } from './message.service';
import { SdkService } from './sdk.service';

interface Props {
  type: string; // student or teacher
  self: ImUserVO;
  peer: ImUserVO;
}

const { type, self, peer } = defineProps<Props>();

declareProviders([
  ImService,
  SdkService,
  MessageService,
  AudioActionService,
  CodeActionService,
  EmojiActionService,
  ImageActionService,
  ScreenshotActionService,
  EventService,
  ContextService,
]);

const service = useService(ImService);
const eventService = useService(EventService);

onMounted(() => {
  service.init(type, self, peer);
  eventService.init();
});

onBeforeUnmount(() => {
  // 销毁服务数据
  service.sdkService.destroy();
  eventService.destroy();
});
</script>

<template>
  <div>
    <ImChatEntry v-show="service.entryVisible" />
    <ImChatBox v-show="!service.entryVisible" />
  </div>
</template>
